module.exports = __webpack_public_path__ + "img/scale.b33a0217.png";